import { Stack, Typography } from "@mui/material";
import React from "react";
import { LinearProgress } from "src/ui/components/shared/atoms/LinearProgress";

interface DownloadProgressBarProps {
  progress: number | null;
  height?: number;
  width?: number | string;
}

export const DownloadProgressBar = ({
  progress,
  height = 6,
  width,
}: DownloadProgressBarProps) => {
  const known = progress !== null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ width: width ?? "100%" }}
    >
      <LinearProgress
        variant={known ? "determinate" : "indeterminate"}
        value={progress ?? 0}
        sx={{ flex: 1, height }}
      />
      {known ? (
        <Typography
          variant="body3"
          sx={(theme) => ({
            color: theme.newColors.neutral.gray500,
            minWidth: 42,
            flexShrink: 0,
            textAlign: "right",
          })}
        >
          {progress}%
        </Typography>
      ) : null}
    </Stack>
  );
};
